<template>
  <div>
    <v-card
      class="card altura-responsiva-fornecedor-produto"
      :class="{'elevation-0': elevationHidden}"
      style="font-size: 12px"
    >
      <h4 class="text-color-systock mt-n3" id="detalhe-produto">
        Detalhes do produto

        <raio-x
          title="Raio x do produto"
          class="ml-1"
        />

        <img-produto-dialog
          v-if="detalhesProduto.exibirImagemProduto"
          class="ml-1"
          :produto="detalhesProduto"
          title="Imagem do Produto"
        ></img-produto-dialog>

        <v-spacer />

        <div v-if="status[0]" class="text-color-systock d-flex align-center font-14">
          <span class="dot" :style="{ backgroundColor: status[0].cor }"></span>
          <span class="ml-1">{{ verificarNivelServico(detalhesProduto.nivel_servico) }}</span>
        </div>
      </h4>

      <div class="mt-n1-5 d-flex align-center font-12 font-weight-bold text-color-systock">
        <span class="text-truncate" :title="`${detalhesProduto.idproduto} - ${detalhesProduto.descricao_produto}`" v-text="`${detalhesProduto.idproduto} - ${detalhesProduto.descricao_produto}`" />
        <span class="text-no-wrap" v-if="detalhesProduto.embalagem">&nbsp;{{ `=> EMB : ${detalhesProduto.embalagem}` }}</span>
        <v-icon class="ml-2px" small title="Detalhamento do Produto" @click="dialogDetalhes = true">mdi-information-outline</v-icon>
      </div>

      <table class="w-full mt-n3px">
        <tr>
          <td>
            <Legenda titulo="Prioridade" legenda="Representa a importância decorrente da combinação de todas as curvas apresentadas. Sendo inversamente proporcional, ou seja, quanto menor o valor maior a importância do item e consequentemente, maior a prioridade de análise">
              <p class="ma-0 font-weight-bold">Prioridade</p>
            </Legenda>
            <span>{{ Helpers.formatarValor(detalhesProduto.peso_compras) }}</span>
          </td>
          <td>
            <div class="ma-0 font-weight-bold d-flex align-center text-truncate">
              <span>Preço compra</span>
              <CloseUp :produto="detalhesProduto" />
            </div>
            <span>
              <FormatarMoeda :tipo="detalhesProduto.moeda" />

              <template v-if="embalagemMasterAtivada">
                <template v-if="detalhesProduto.tipo_fator_conversao === 'D'">
                  {{ Helpers.formatarValor(detalhesProduto.preco_compra * detalhesProduto.multiplo_compra || 0) }}
                </template>

                <template v-else>
                  {{ Helpers.formatarValor(detalhesProduto.preco_compra / detalhesProduto.multiplo_compra || 0) }}
                </template>
              </template>

              <template v-else>
                {{ Helpers.formatarValor(detalhesProduto.preco_compra) }}
              </template>
            </span>
          </td>
          <td>
            <div class="font-weight-bold d-flex align-center">
              <Legenda titulo="Ressuprimento" legenda="Ressuprimento ou tempo de reabastecimento ou Lead time, é o prazo completo para a reposição da SKU, contado desde a identificação da respectiva necessidade, passando pelo processo de reposição (planejamento e aquisição), fabricação e despacho pelo fornecedor, até o recebimento e liberação para consumo">
                <span>Ressuprimento&nbsp;</span>
              </Legenda>
              <v-icon :size="15" @click="dialogRessuprimento = true;alterarSelectRessuprimento()">mdi-pencil</v-icon>
            </div>
            <span>{{ Helpers.formatarValorComCasas(detalhesProduto.tempo_medio_ressuprimento, 1) }} dias</span>
          </td>
          <td>
            <p class="ma-0 font-weight-bold">
              <Legenda titulo="Lote Mínimo" legenda="Trata-se de uma quantidade mínima que o fornecedor está disposto a efetuar a venda, abaixo dessa quantidade não é interessante produzir/vender">
                <lote-minimo
                  :produto="{...detalhesProduto, filial: filialCompra }"
                  @alterou-lote-minimo="() => atualizarDetalhesProdutosAposAlterarLoteMinimo()"
                />
              </Legenda>
            </p>
            <span>
              <template v-if="detalhesProduto.lote_minimo">
                {{Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.lote_minimo))}}

                <template v-if="embalagemMasterAtivada">
                  {{detalhesProduto.unidade_master}}
                </template>
                <template v-else>{{detalhesProduto.unidade_compra}}</template>
              </template>
              <template v-else>&nbsp;</template>
            </span>
          </td>
          <td>
            <Legenda titulo="Similares">
              <p class="ma-0 font-weight-bold">Similares</p>

              <template #legenda>
                São itens análogos, que possuem a mesma natureza, semelhança, podendo ou não ter a mesma equivalência. Podendo ser classificados como:<br />
                <span class="font-weight-medium">INTERCAMBIÁVEIS</span>: Itens Equivalentes em qualidade e preço. Na ausência de um o cliente leva o outro;<br />
                <span class="font-weight-medium">NÃO-INTERCAMBIÁVIS</span>: Semelhantes mas não equivalentes. Na ausência de um o cliente NÃO leva o outro;<br />
              </template>
            </Legenda>

            <span>
              <dialog-similares @fechou-dialog="fechouDialogSimilares()" />
            </span>
          </td>
          <td>
            <p class="ma-0 font-weight-bold">Conversão</p>
            <span>
              {{ parseFloat(detalhesProduto.fator_conversao) | numeral("0.0000") }}
              <v-icon
                v-if="detalhesProduto.multiplo_compras === 'S'"
                small
                @click="getEmbalagem()"
                title="Setar Embalagem Padrão"
                style="margin-left: 20px"
                class="mt-n9"
              >
                mdi-information-outline
              </v-icon>
            </span>
          </td>
        </tr>

        <tr>
          <td rowspan="2">
            <Legenda titulo="Nível estoque" legenda="Informa em percentual a quantidade de estoque de uma determinada SKU, frente aos seus parâmetros de estoque máximo e segurança">
              <p class="ma-0 font-weight-bold">Nível estoque</p>
            </Legenda>

            <Legenda titulo="Nível do estoque" :legenda="`${Helpers.formatarValor(detalhesProduto.nivel_estoque)}%`">
              <NivelEstoqueProgressCircular :tamanho="48" :valor="parseInt(detalhesProduto.nivel_estoque)" :status-produto="detalhesProduto.status_produto" />
            </Legenda>
          </td>
          <td>
            <detalhamento-estoque
              :produto="{...detalhesProduto, filial: filialCompra}"
              @update:parametrizacao="$emit('atualizar-produtos-total')"
            />

            <span v-if="detalhesProduto.produto_em_analise_por_lote" class="text-gray-300">
              {{Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.estoque_origem))}} /
            </span>

            <span>{{Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.estoque))}}</span>
          </td>
          <td>
            <Legenda titulo="Estético">
              <p class="ma-0 font-weight-bold">Estético</p>

              <template #legenda>
                Viés de exposição de loja. Compra-se uma quantidade necessária para melhorar a exposição dos produtos, desconsiderando a demanda de vendas.<br />
                <span class="font-weight-medium">Prós</span>: otimização na exposição da loja, gôndolas sempre cheias atraem clientes, estética potencializa a venda;<br />
                <span class="font-weight-medium">Contra</span>: excesso de produtos, muito capital imobilizado, capital inicial elevado para formação de novas filiais, análise subjetiva dependendo da experiência e bom senso do time;<br />
              </template>
            </Legenda>
            <span>{{Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.estoque_minimo))}}</span>
          </td>
          <td>
            <p class="ma-0 font-weight-bold">Bloqueado</p>
            <span>{{Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.estoque_bloqueado))}}</span>
          </td>
          <td>
            <div>
              <span class="ma-0 font-weight-bold">Itens Pendentes</span>
              <v-icon small color="#D60E2B" class="ml-1px">mdi-truck</v-icon>
            </div>
            <div class="d-flex align-center">
              <p class="ma-0 mr-1">
                <span title="Quantidade Pendente" style="color: #D60E2B; cursor: help;">
                  {{Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.compra_transito))}}
                </span>
                /
                <span title="Quantidade Faturada" style="color: #044716; cursor: help;">
                  {{ Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.compra_faturada)) }}
                </span>
              </p>

              <ComparacaoProdutos
                v-if="detalhesProduto.produtos"
                :id_grupo="Number(grupoCompra)"
                :filial="Number(filialCompra)"
                :id_produto_combinado="String(detalhesProduto.idproduto)"
                :campos_visiveis="['idproduto', 'descricao_produto', 'descricao_fornecedor', 'estoque_transito', 'estoque_faturado']"
              >
                <template #ativador="{callback}">
                  <v-icon :size="15" @click="callback">mdi-information-outline</v-icon>
                </template>
              </ComparacaoProdutos>
            </div>
          </td>
        </tr>

        <tr>
          <td>
            <p class="ma-0 font-weight-bold">Avaria</p>
            <span>{{Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.estoque_avaria))}}</span>
          </td>
          <td>
            <p class="ma-0 font-weight-bold">Reservado</p>
            <span>{{Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.estoque_reservado))}}</span>
          </td>
          <td>
            <template v-if="detalhesProduto.qtde_registros_produtos_separacao > 0">
              <div class="d-flex align-center font-weight-bold">
                <span>Transferência</span>
                <Transferencia :produto="{...detalhesProduto, idgrupo: grupoCompra, filial: filialCompra}" />
              </div>
              <span>{{Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.qtde_transferencia))}}</span>
            </template>
          </td>

          <td>
            <div class="d-flex align-center">
                <Legenda
                  titulo="Herança"
                  legenda="Permite que o produto considere o comportamento de vendas de outro produto como referência para projeção, principalmente quando não há histórico próprio."
                >
                  <span
                    class="ma-0 font-weight-bold"
                    :class="{ 'text-red cursor-help': detalhesProduto.id_heranca }"
                    :title="detalhesProduto.id_heranca ? 'Fora de linha por herança' : ''"
                    v-text="'Herança'"
                  />
                </Legenda>

                <Heranca
                  style="display: inline-flex;"
                  :produto="{
                    ...detalhesProduto,
                    id_produto: detalhesProduto.idproduto,
                    id_produto_heranca: detalhesProduto.id_heranca ? detalhesProduto.id_heranca : null,
                    tipo_heranca: detalhesProduto.tipo_heranca ? detalhesProduto.tipo_heranca : null
                  }"
                  @update:heranca="aposSalvarHeranca"
                />
            </div>

            <div class="text-truncate w-90" :title="`${detalhesProduto.id_heranca} - ${detalhesProduto.descricao_heranca}`">
              <template v-if="detalhesProduto.id_heranca">
                {{ detalhesProduto.id_heranca }} - {{ detalhesProduto.descricao_heranca }}
              </template>
              <template v-else>-</template>
            </div>
          </td>

          <td>
            <p class="ma-0 font-weight-bold text-truncate">Data Herança</p>
            <span>
              <template v-if="detalhesProduto.id_heranca">{{ detalhesProduto.cadastro_heranca }}</template>
              <template v-else>-</template>
            </span>
          </td>
        </tr>

        <tr>
          <td>
            <p class="ma-0 font-weight-bold">Status Produto</p>
            <Legenda titulo="Status do Produto" :legenda="detalhesProduto.status_produto">
              <div class="w-85 text-truncate cursor-help">
                {{ detalhesProduto.status_produto }}
              </div>
            </Legenda>
          </td>

          <td v-if="detalhesProduto.campos_personalizados && Number(detalhesProduto.campos_personalizados.valor_ultima_compra.valor) > 0">
            <p class="ma-0 font-weight-bold">Últ. Entrada</p>

            <LegendaTotalGeralEPorFilial
              titulo="Valor da Última Compra"
              :campo_personalizado="detalhesProduto.campos_personalizados.valor_ultima_compra"
            />
          </td>

          <td v-if="detalhesProduto.campos_personalizados && Number(detalhesProduto.campos_personalizados.valor_ultima_entrada_sem_st.valor) > 0">
            <p class="ma-0 font-weight-bold">Últ. Ent. sem ST</p>

            <LegendaTotalGeralEPorFilial
              titulo="Valor da Última Entrada sem ST"
              :campo_personalizado="detalhesProduto.campos_personalizados.valor_ultima_entrada_sem_st"
            />
          </td>

          <td v-if="!detalhesProduto.produto_eh_combinacao" colspan="2">
            <div class="d-flex align-center">
              <div class="d-flex flex-column flex-grow-3">
                <span class="font-weight-bold">Necessidade DRP</span>
                <span>{{ detalhesProduto.existe_necessidade_drp ? 'SIM' : 'NÃO' }}</span>
              </div>

              <AnaliseDrpEstoqueFiliais
                :idgrupo="parseInt(detalhesProduto.id_grupo)"
                :idfilial="parseInt(filialCompra)"
                :idproduto="String(detalhesProduto.idproduto)"
                :descricao_produto="detalhesProduto.descricao_produto"
                content_class="ma-0 mt-n4"
                class="ml-2"
              />
            </div>
          </td>

        </tr>
      </table>

      <v-layout v-if="detalhesProduto.sazonalidade && detalhesProduto.data_inicial && detalhesProduto.data_final">
        <v-flex xs2>
          <h4>Sazonal</h4>
          <p>{{ detalhesProduto.sazonalidade ? 'Sim':'Não' }}</p>
        </v-flex>

        <v-flex xs3 class="ml-n1">
          <h4>Data Inicial</h4>

          <span class="text-truncate">
            {{ detalhesProduto.data_inicial.split(',')[0] }}
          </span>

          <v-tooltip bottom v-if="detalhesProduto.data_inicial.split(',').length > 1">
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                v-if="detalhesProduto.data_inicial.split(',').length"
                class="cursor-pointer"
              >
                (+{{ detalhesProduto.data_inicial.split(',').length - 1 }})
              </span>
            </template>

            <span v-for="(dado, idx_inicial) in detalhesProduto.data_inicial.split(',')" :key="idx_inicial">
              <p v-if="idx_inicial != 0" class="pa-0 ma-0">{{ dado }}</p>
            </span>
          </v-tooltip>
        </v-flex>

        <v-flex xs3 class="ml-n1">
          <h4>Data Final</h4>
          <span class="text-truncate">
            {{ detalhesProduto.data_final.split(',')[0] }}
          </span>

          <v-tooltip bottom v-if="detalhesProduto.data_final.split(',').length > 1">
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                v-if="detalhesProduto.data_final.split(',').length"
                class="cursor-pointer"
              >
                (+{{ detalhesProduto.data_final.split(',').length - 1 }})
              </span>
            </template>

            <span v-for="(dado, idx_final) in detalhesProduto.data_final.split(',')" :key="idx_final">
              <p class="pa-0 ma-0" v-if="idx_final != 0">{{ dado }}</p>
            </span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <v-divider class="pb-2px" />

      <div class="d-flex align-center">
        <span class="font-12 font-weight-bold">
          Última Compra
        </span>

        <UltimasCompras
          :produto="{...detalhesProduto, filial: filialCompra, id_produto: detalhesProduto.idproduto}"
          @atualizar-listagem-produtos="cardSelecionado.metodo(fornecedorCompra.id)"
          @update:desconsiderar-pedido-em-transito="atualizarDetalhesProdutosAposAlterarUltimaCompras"
        />

        <ComparativoPreco
          v-if="!detalhesProduto.produto_eh_combinacao"
          :produto="{
            id_grupo: detalhesProduto.id_grupo,
            id_filial: filialCompra,
            id_produto: detalhesProduto.idproduto,
          }"
        />

        <DashComparandoEvolucaoDePrecoDeCompras
          :produto="{...detalhesProduto, filial: filialCompra, id_produto: detalhesProduto.idproduto}"
        />
      </div>

      <v-layout v-if="detalhesUltimaCompra && detalhesUltimaCompra.ordem_compra">
        <v-flex xs2>
          <h4>Pedido</h4>
          <p>{{ detalhesUltimaCompra.ordem_compra }}</p>
        </v-flex>
        <v-flex xs2>
          <h4>Total Item</h4>
          <FormatarMoeda :tipo="detalhesProduto.moeda" />
          {{ Helpers.formatarValorComCasas(detalhesUltimaCompra.total_compra, 2) }}
        </v-flex>
        <v-flex xs2>
          <h4>Quantidade</h4>
          <p>{{Helpers.formatarValor(converteEmbalagemValor(detalhesUltimaCompra.qtde))}}</p>
        </v-flex>
        <v-flex xs2>
          <h4>Solicitação</h4>
          <p>{{ detalhesUltimaCompra.data_solicitacao }}</p>
        </v-flex>
        <v-flex xs2>
          <h4>Previsão</h4>
          <p>{{ detalhesUltimaCompra.data_previsao }}</p>
        </v-flex>
        <v-flex xs2 v-if="detalhesUltimaCompra.data_entrega">
          <h4>Entrada</h4>
          <p>{{ detalhesUltimaCompra.data_entrega }}</p>
        </v-flex>
        <v-flex xs2 v-else>
          <h4 class="text-truncate">Tempo entrega</h4>
          <p
            class="lead_time_atraso text-truncate"
            v-if="parseInt(detalhesUltimaCompra.atraso) > 0"
          >
            {{ detalhesUltimaCompra.atraso }} dia(s) atraso
          </p>
          <p
            class="lead_time_ok text-truncate"
            v-if="parseInt(detalhesUltimaCompra.atraso) <= 0"
          >
            {{ Math.abs(detalhesUltimaCompra.atraso) }} dia(s)
          </p>
        </v-flex>
      </v-layout>
      <v-layout v-else>
        <v-flex xs12>
          <p>Não há informações.</p>
        </v-flex>
      </v-layout>
      <v-layout style="margin-top: -10px">
        <div class="d-flex align-center">
          <h4 class="text-color-systock">
            Média de vendas nos últimos meses
          </h4>
          <UltimasVendasProduto
            :produto="{...detalhesProduto, filial: filialCompra}"
            :click_bar="click_bar"
            @consumos-desconsiderados="consumoDesconsiderado"
          />
        </div>
      </v-layout>
      <v-layout
        v-if="analiseProduto.media_3_meses"
        style="margin-bottom: -13px"
      >
        <v-flex xs2>
          <h4>3 meses</h4>
          <div class="d-flex align-center">
            <p class="ma-0">{{Helpers.formatarValor(converteEmbalagemValor(analiseProduto.media_3_meses[0][0].total))}}</p>

            <ComparacaoProdutos
              v-if="detalhesProduto.produtos"
              :id_grupo="Number(grupoCompra)"
              :id_produto_combinado="String(detalhesProduto.idproduto)"
              :campos_visiveis="['idproduto', 'descricao_produto', 'descricao_fornecedor', 'media_venda_ult_trimestre']"
            >
              <template #ativador="{callback}">
                <v-icon :size="15" @click="callback">mdi-information-outline</v-icon>
              </template>
            </ComparacaoProdutos>
          </div>
        </v-flex>
        <v-flex xs2>
          <h4>6 meses</h4>
          <div class="d-flex align-center">
            <p class="ma-0">{{Helpers.formatarValor(converteEmbalagemValor(analiseProduto.media_6_meses[0][0].total))}}</p>

            <ComparacaoProdutos
              v-if="detalhesProduto.produtos"
              :id_grupo="Number(grupoCompra)"
              :id_produto_combinado="String(detalhesProduto.idproduto)"
              :campos_visiveis="['idproduto', 'descricao_produto', 'descricao_fornecedor', 'media_venda_ult_semestre']"
            >
              <template #ativador="{callback}">
                <v-icon :size="15" @click="callback">mdi-information-outline</v-icon>
              </template>
            </ComparacaoProdutos>
          </div>
        </v-flex>
        <v-flex xs2>
          <h4>12 meses</h4>
          <div class="d-flex align-center">
            <p class="ma-0">{{Helpers.formatarValor(converteEmbalagemValor(analiseProduto.media_12_meses[0][0].total))}}</p>

            <ComparacaoProdutos
              v-if="detalhesProduto.produtos"
              :id_grupo="Number(grupoCompra)"
              :id_produto_combinado="String(detalhesProduto.idproduto)"
              :campos_visiveis="['idproduto', 'descricao_produto', 'descricao_fornecedor', 'media_venda_ult_ano']"
            >
              <template #ativador="{callback}">
                <v-icon :size="15" @click="callback">mdi-information-outline</v-icon>
              </template>
            </ComparacaoProdutos>
          </div>
        </v-flex>
        <v-flex xs4>
          <div class="d-flex align-center">
            <Legenda titulo="Projeção de vendas" legenda="Valor calculado do quanto se espera vender no próximo mês, baseado no seu comportamento histórico">
              <h4>Projeção de vendas&nbsp;</h4>
            </Legenda>

            <ProjecaoVendasParametrizavel
              :produto="{
                id_grupo: detalhesProduto.id_grupo,
                id_filial: Number(filialCompra) === 0 ? 9999 : filialCompra,
                id_produto: detalhesProduto.idproduto,
                produto_eh_combinacao: detalhesProduto.produto_eh_combinacao
              }"
              :abrir_modal="dialog_tipo_projecao_venda"
              :tipo_fator_conversao="detalhesProduto.tipo_fator_conversao"
              :multiplo_compra="Number(detalhesProduto.multiplo_compra)"
              @update:tipo-projecao-aplicado="
                $emit('atualizar-produtos-total', {});
                $emit('ocultarDetalhesProduto', true);
              "
            />
          </div>

          <div class="d-flex">
            <p class="ma-0">{{Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.consumo_medio_mensal))}}</p>

            <ComparacaoProdutos
              v-if="detalhesProduto.produtos"
              :id_grupo="Number(grupoCompra)"
              :id_produto_combinado="String(detalhesProduto.idproduto)"
              :campos_visiveis="['idproduto', 'descricao_produto', 'descricao_fornecedor', 'consumo_medio_mensal']"
            >
              <template #ativador="{callback}">
                <v-icon :size="15" @click="callback">mdi-information-outline</v-icon>
              </template>
            </ComparacaoProdutos>

            <div
              class="d-flex align-center ml-2 mr-n10 mb-2 px-1 bra-5"
              :style="formatarBadgeTipoProjecao"
              :class="truncarTipoProjecaoVendas
                  ? 'w-70-porcento' : ''"
            >
              <v-icon
                v-if="detalhesProduto.tipo_projecao_vendas !== 'padrao_systock'"
                class="mr-1"
                size="15"
                :color="formatarBadgeTipoProjecao.color"
              >
                $ProjectorScreenChart
              </v-icon>

              <span
                :class="truncarTipoProjecaoVendas
                  ? 'tailwind-truncate w-80-porcento' : ''"
              >
                {{ formatarTipoProjecaoVendas(detalhesProduto.tipo_projecao_vendas) }}
                {{ truncarTipoProjecaoVendas ? '...' : ''}}
              </span>
            </div>
          </div>
        </v-flex>
        <v-flex xs4 v-if="exibirFatorAtuacao">
          <div class="d-flex align-center">
            <Legenda titulo="Influenciar Projeção" legenda="Refere-se a possibilidade do comprador influenciar tanto para mais quanto para menos a projeção de vendas calculada">
              <h4 class="text-truncate">Influenciar Projeção&nbsp;</h4>
            </Legenda>

            <FatorAtuacao
              @atualizar-produtos="$emit('atualizarProdutos', $event)"
              @ocultar-detalhes-produto="$emit('ocultarDetalhesProduto', true)"
            ></FatorAtuacao>
          </div>
          <p v-if="detalhesProduto.fator_atuacao > 1">
            <span style="color: green">
              {{ Helpers.formatarValor(detalhesProduto.percentual) }}%
            </span>
          </p>
          <p v-else-if="detalhesProduto.fator_atuacao < 1">
            <span style="color: red">
              -{{ Helpers.formatarValor(detalhesProduto.percentual) }}%
            </span>
          </p>
          <p v-else>0%</p>
        </v-flex>
      </v-layout>

      <DialogModeloPrevisaoAtual
        v-model="dialog_modelo_previsao_atual"
        v-if="detalhesProduto.tipo_projecao_vendas !== 'padrao_systock' && 1 === 2"
        :tipo_projecao_vendas="tipoProjecaoVendas"
        @confirmar="() => dialog_tipo_projecao_venda = !dialog_tipo_projecao_venda"
        @fechar="() => dialog_modelo_previsao_atual = false"
      >
        <template #activator="{ on, attrs }">
          <div
            v-bind="attrs" v-on="on"
            style="background-color: #EEE8FD; color: #5316D6"
            class="ma-1 pa-1 d-inline-flex align-center bra-7 cursor-pointer"
            @click="() => dialog_modelo_previsao_atual = true"
          >
            <v-icon class="mr-1" size="17" color="#5316D6">$MegaphoneSimple</v-icon>
            <span class="font-13">Promo</span>
            <v-icon class="ml-1" size="17" color="#5316D6">$Info</v-icon>
          </div>
        </template>
      </DialogModeloPrevisaoAtual>

      <v-divider></v-divider>

      <v-layout style="padding: 8px 0 0 0">
        <v-flex xs12>
          <div id="select-filial-chart" style="position: absolute; left: auto; right: 0;" class="mr-1 mt-1">
            <v-select
              style="z-index: 4"
              v-model="selects.filial.value"
              :items="selects.filial.items"
              hide-details
              item-value="filial"
              item-text="descricao"
              outlined
              dense
            >
              <template  v-slot:label>
                <p class="ma-0 mt-n1">Filial</p>
              </template>
            </v-select>
          </div>
        </v-flex>
      </v-layout>

      <div class="w-full">
        <GraficoMovimentacoesEstoqueProduto
          id="detalhes-produto"
          :style="formatarAlturaGrafico"
          :produto="parametrosChartMovimentacoesEstoque"
          class="mt-n4"
          ativar_filtro_revenda_direta
          @click:bar="click_bar = $event"
        />
      </div>
    </v-card>
    <!-- Modal Ressuprimento -->
    <v-layout justify-center>
      <v-dialog v-model="dialogRessuprimento" persistent max-width="800" content-class="bra-20">
        <v-card>
          <v-card-title primary-title class="pl-6 py-4">
            <span>Tempo de ressuprimento manual</span>
            <v-spacer />
            <v-btn icon @click="dialogRessuprimento = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pt-2 pb-0">
            <div class="d-flex">
              <v-flex xs8>
                <v-select
                  v-model="vselect_id_tipo"
                  :items="sel_dados_tipo"
                  label="Tipo ajuste"
                  item-value="id"
                  item-text="name"
                  outlined
                ></v-select>
              </v-flex>
              <v-flex xs4 class="d-flex align-center justify-center">
                <tendencia-ultimas-entradas />

                <v-btn
                  class="primary ml-5"
                  title="Imprimir Relatorio"
                  @click="relatorio()"
                >
                  <v-icon color="#fff">mdi-file-document</v-icon>
                </v-btn>
              </v-flex>
            </div>

            <div class="d-flex">
              <v-flex xs4>
                <v-select
                  v-model="vselect_id"
                  :items="sel_dados"
                  label="Ressuprimento Manual"
                  outlined
                  class="mr-2"
                  item-value="id"
                  item-text="name"
                  @change="mudarRessuprimentoManual(vselect_id)"
                ></v-select>
              </v-flex>
              <v-flex xs4>
                <text-field-formatador-de-valor
                  v-model="vtext_id"
                  class="ml-2"
                  label="Quantidade de dias"
                  remover-valor-irrelevante
                  maxlength="10"
                  outlined
                  type="text"
                  inputmode="numeric"
                  @focus="$event.target.select()"
                  @keypress.enter="ajustarTempoRessuprimentoGrupo()"
                  :disabled="vselect_id === 'N'"
                >
                </text-field-formatador-de-valor>
              </v-flex>
              <v-flex xs4 class="text-center pt-2">
                <v-btn
                  color="#043554"
                  @click="ajustarTempoRessuprimentoGrupo()"
                >
                  <h4 style="color: #fff">Alterar</h4>
                </v-btn>
              </v-flex>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- Modal Fator Atuacao -->
    <v-layout justify-center>
      <v-dialog v-model="dialogFatorAtuacao" persistent max-width="600">
        <v-card>
          <v-layout align-center class="mb-3 pt-1">
            <v-flex xs1>
              <v-btn color="#000" icon @click="dialogFatorAtuacao = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs10>
              <v-card-title class="headline" style="color: #043554"
              >Fator de Atuação</v-card-title
              >
            </v-flex>
          </v-layout>
          <v-card-text>
            <p>Data Limite para o vencimento do Fator de Atuação*</p>
            <div
              v-if="
                detalhesProduto.percentual == 0 ||
                !detalhesProduto.data_limite_fa
              "
            >
              <v-radio-group v-model="dataLimiteAjuste">
                <v-radio label="Uma Semana" value="7" class="mb-3"></v-radio>
                <v-radio label="Um Mês" value="30"></v-radio>
              </v-radio-group>
              <v-text-field
                outlined
                v-model="dataLimiteAjuste"
                label="Data Limite*"
                type="date"
                :error-messages="errorDataLimite"
              ></v-text-field>
            </div>
            <div v-else>
              <v-text-field
                outlined
                v-model="dataLimiteAjuste"
                label="Data Limite*"
                type="date"
                :error-messages="errorDataLimite"
              ></v-text-field>
            </div>
            <v-layout>
              <v-flex xs12>
                <v-select
                  outlined
                  v-model="selects.produtoForn.value"
                  :items="selects.produtoForn.items"
                  label="Selecione um Produto"
                  item-value="id"
                  item-text="descricao"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs7>
                <v-select
                  outlined
                  v-model="selects.tipoAjuste.value"
                  :items="selects.tipoAjuste.items"
                  label="Selecione o Tipo de Ajuste*"
                  item-value="id"
                  item-text="tipo"
                ></v-select>
              </v-flex>
              <v-flex xs5>
                <v-text-field
                  class="ml-5"
                  outlined
                  v-model="qtdeAjuste"
                  label="Informe o Percentual*"
                  placeholder="Ex: 50"
                  :error="
                    selects.tipoAjuste.value == 2 && qtdeAjuste == 100
                  "
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions style="margin-top: -10px">
            <v-spacer></v-spacer>
            <v-btn
              color="black darken-1"
              text
              @click="dialogFatorAtuacao = false"
            >Sair</v-btn
            >
            <v-btn color="black darken-1" text @click="editarFatorAtuacao()"
            >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- Modal detalhes -->
    <v-layout justify-center>
      <v-dialog
        v-model="dialogDetalhes"
        fullscreen
        hide-overlay max-width="800"
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="#042333">
            <v-btn color="#FFF" icon @click="dialogDetalhes = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Detalhes do produto</v-toolbar-title>
            <converter-embalagem class="ml-3" />

            <v-spacer></v-spacer>

            <p class="pt-4">
              {{detalhesProduto.descricao_produto}}
            </p>

            <p class="pt-4 ml-10" v-if="status[0]">
              <span class="dot" :style="{ backgroundColor: status[0].cor }"></span>
              {{ detalhesProduto.nivel_servico }}
              <v-icon class="dot" :title="status[0].descritivo" id="icon-info">
                mdi-information-outline
              </v-icon>
            </p>
          </v-toolbar>
          <v-card-text class="black--text px-2">
            <h3 class="my-3 ml-2">Características do Produto</h3>

            <table id="table-detalhes-produto">
              <tr class="text-left">
                <td>
                  <p class="subtitle-2">Cód. Produto</p>
                  <p>{{ detalhesProduto.idproduto }}</p>
                </td>
                <td>
                  <p class="subtitle-2">Cód. Fabricante</p>
                  <p>{{ detalhesProduto.cod_produto }}</p>
                </td>
                <td colspan="6">
                  <p class="subtitle-2">Cód. Barras</p>
                  <p>{{detalhesProduto.codigo_barras}}</p>
                </td>
              </tr>
              <tr class="text-left">
                <td>
                  <p class="subtitle-2">Custo de Aquisição</p>
                  <p>{{ detalhesProduto.classificacao_financeira }}</p>
                </td>
                <td>
                  <p class="subtitle-2">Criticidade Resultado</p>
                  <p>{{ detalhesProduto.classificacao_criticidade }}</p>
                </td>
                <td>
                  <p class="subtitle-2">Comprabilidade</p>
                  <p>{{ detalhesProduto.classificacao_comprabilidade }}</p>
                </td>
                <td colspan="2">
                  <p class="subtitle-2">Frequência Saída</p>
                  <p>{{ detalhesProduto.classificacao_popularidade }}</p>
                </td>
              </tr>
              <tr class="text-left">
                <td>
                  <p class="subtitle-2">Unidade Venda</p>
                  <p>{{ detalhesProduto.unidade_venda }}</p>
                </td>
                <td>
                  <p class="subtitle-2">Unidade Compra</p>
                  <p>{{ detalhesProduto.unidade_compra }}</p>
                </td>
                <td>
                  <p class="subtitle-2">Perfil de Demanda</p>
                  <p>{{ detalhesProduto.perfil_demanda }}</p>
                </td>
                <td colspan="4">
                  <p class="subtitle-2">Ressuprimento</p>
                  <p>{{ Helpers.formatarValorComCasas(detalhesProduto.tempo_medio_ressuprimento, 1) }} dias</p>
                </td>
              </tr>
              <tr class="text-left">
                <td>
                  <p class="subtitle-2">Estoque</p>
                  <p>{{ Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.estoque)) }}</p>
                </td>
                <td>
                  <p class="subtitle-2">Cobertura de Estoque</p>
                  <p>{{ Helpers.formatarValorComCasas(detalhesProduto.cobertura_estoque, 1) }} dias</p>
                </td>
                <td>
                  <p class="subtitle-2">
                    Estoque Segurança
                  </p>
                  <p>{{ Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.estoque_seguranca)) }}</p>
                </td>

                <td title="Cobertura Estoque Segurança">
                  <p class="subtitle-2 text-no-wrap">
                    Cob. Estoque Segurança
                    <EstoqueSeguranca
                      :detalhes_produto="detalhesProduto"
                      @atualizar-cobertura="atualizarCobertura" />
                  </p>
                  <p>{{ Helpers.formatarValor(detalhesProduto.cobertura_estoque_seguranca) }} dias</p>
                </td>

                <td>
                  <p class="subtitle-2">Ponto Pedido</p>
                  <p>{{ Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.ponto_pedido)) }}</p>
                </td>
                <td>
                  <p class="subtitle-2">Estoque Máximo</p>
                  <p>{{ Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.estoque_maximo)) }}</p>
                </td>
              </tr>

              <tr class="text-left">
                <td>
                  <p class="subtitle-2">Estoque Estético</p>
                  <p>{{ Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.estoque_minimo)) }}</p>
                </td>
                <td :colspan="ativo_estetico_por_pp ? 1 : 5">
                  <p class="subtitle-2">Cobertura de Estoque Estético</p>
                  <p>{{ Helpers.formatarValorComCasas(detalhesProduto.cobertura_estoque_minimo, 1) }} dias</p>
                </td>

                <template v-if="ativo_estetico_por_pp">
                  <td :colspan="2">
                    <p class="subtitle-2">
                      Estoque Segurança Estético
                    </p>
                    <p>{{ Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.estoque_seguranca_estetico)) }}</p>
                  </td>
                  <td>
                    <p class="subtitle-2">Ponto Pedido Estético</p>
                    <p>{{ Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.ponto_pedido_estetico)) }}</p>
                  </td>
                  <td>
                    <p class="subtitle-2">Estoque Máximo Estético</p>
                    <p>{{ Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.estoque_maximo_estetico)) }}</p>
                  </td>
                </template>
              </tr>

              <tr class="text-left">
                <td>
                  <p class="subtitle-2">Estoque Bloqueado</p>
                  <p>{{ Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.estoque_bloqueado)) }}</p>
                </td>
                <td>
                  <!-- #zendesk-4571 -->
                  <p class="subtitle-2">Frequência Média de Apanhe</p>
                  <p>{{ Helpers.formatarValor(detalhesProduto.tempo_medio_apanhe) }}</p>
                </td>
                <td>
                  <p class="subtitle-2" style="color: #d60e2b">
                    Em trânsito
                    <v-icon color="#D60E2B">mdi-truck</v-icon>
                  </p>
                  <p style="color: #d60e2b">
                    {{ Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.compra_transito)) }}
                  </p>
                </td>
                <td>
                  <p class="subtitle-2">Nível de estoque</p>
                  <p>{{ Helpers.formatarValor(detalhesProduto.nivel_estoque) }}%</p>
                </td>
                <td colspan="4">
                  <p class="subtitle-2">Fator Conversão</p>
                  <p>{{ Helpers.formatarValor(detalhesProduto.fator_conversao) }}</p>
                </td>
              </tr>
              <tr class="text-left">
                <td>
                  <p class="subtitle-2">Projeção de vendas</p>
                  <p>{{ Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.consumo_medio_mensal)) }}</p>
                </td>
                <td>
                  <p class="subtitle-2">Desvio Padrão Consumo</p>
                  <p>{{ Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.desvio_padrao_consumo)) }}</p>
                </td>
                <td colspan="4">
                  <p class="subtitle-2">Coeficiente Variação</p>
                  <p>{{ Helpers.formatarValor(converteEmbalagemValor(detalhesProduto.coeficiente_variacao)) }}%</p>
                </td>
              </tr>
              <tr class="text-left">
                <td colspan="10">
                  <p class="subtitle-2">Cobertura de Estoque Manual</p>
                  <div class="d-flex">
                    <sys-input-formatador
                      v-model="coberturaManualProduto"
                      class="font-resp txt-table-prod sys-input-retangular"
                      dense
                      centralizar
                      :maxDigitos="2"
                      :disabled="detalhesProduto.flag_cobertura_manual === 'N'"
                      @keydown.enter="atualizarCoberturaManualProduto(coberturaManualProduto, detalhesProduto)"
                      @focus="$event.target.select()"
                    ></sys-input-formatador>

                    <v-btn
                      color="primary" tile class="ml-3" style="margin-top: 3px"
                      small
                      :dark="detalhesProduto.flag_cobertura_manual === 'S'"
                      @click="atualizarCoberturaManualProduto(coberturaManualProduto, detalhesProduto)"
                      :disabled="detalhesProduto.flag_cobertura_manual == 'N'"
                    >
                      Salvar
                    </v-btn>
                  </div>
                </td>
              </tr>
              <tr class="text-left">
                <td colspan="12">
                  <p class="subtitle-2">Detalhamento Técnico do Produto</p>
                  <p class="ma-0">
                    <template v-if="detalhesProduto.detalhamento_tecnico">{{detalhesProduto.detalhamento_tecnico}}</template>
                    <template v-else>Não há dados disponíveis</template>
                  </p>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- Modal ultimas compras -->
<!--    <v-layout justify-center>-->
<!--      <v-dialog-->
<!--        v-model="dialogUltimas"-->
<!--        fullscreen-->
<!--        hide-overlay-->
<!--        transition="dialog-bottom-transition"-->
<!--      >-->
<!--        <v-card>-->
<!--          <v-toolbar dark color="#042333">-->
<!--            <v-btn icon dark @click="fecharDialogUltimasCompra()">-->
<!--              <v-icon>mdi-close</v-icon>-->
<!--            </v-btn>-->
<!--            <v-toolbar-title>Últimas Compras Grupo</v-toolbar-title>-->

<!--            <converter-embalagem class="ml-3" />-->
<!--          </v-toolbar>-->
<!--          <v-layout style="padding: 10px 10px 0px 10px">-->
<!--            <v-flex xs12>-->
<!--              <v-data-table-->
<!--                id="table-ultimas-compras"-->
<!--                :headers="headersTabelaUltimas"-->
<!--                :items="ultimasCompras.compras"-->
<!--                :fixed-header="true"-->
<!--                :items-per-page="-1"-->
<!--                disable-sort-->
<!--                class="elevation-0 dialog-compra-responsivo table-full-screen"-->
<!--                style="cursor: pointer"-->
<!--              >-->
<!--                <template v-slot:header.pcompra="{header}">-->
<!--                  {{ embalagemMasterAtivada ? "Valor Embalagem" : header.text}}-->
<!--                </template>-->

<!--                <template v-slot:header.pcompraant="{header}">-->
<!--                  {{ embalagemMasterAtivada ? "Valor Embalagem Ant." : header.text}}-->
<!--                </template>-->

<!--                <template v-slot:item="{item}">-->
<!--                  <tr>-->
<!--                    <td>{{ item.fornecedor }}</td>-->
<!--                    <td class="text-center">Filial {{ item.filial }} - {{item.nome_fantasia}}</td>-->
<!--                    <td class="text-right">{{ item.ordem_compra }}</td>-->
<!--                    <td class="text-right">{{ item.item }}</td>-->
<!--                    <td class="text-center">{{ item.produto }}</td>-->
<!--                    <td class="text-center">-->
<!--                      {{ item.data_solicitacao }}-->
<!--                    </td>-->
<!--                    <td class="text-center">{{ item.data_previsao }}</td>-->
<!--                    <td class="text-center">{{ item.data_entrega }}</td>-->
<!--                    &lt;!&ndash; <td>{{ item.qtde_faturada }}</td> &ndash;&gt;-->
<!--                    <td class="text-center">-->
<!--                      {{ item.data_faturamento }}-->
<!--                    </td>-->
<!--                    <td class="text-center">-->
<!--                      {{ embalagemMasterAtivada ? item.unidade_master : item.unidade_compra }}-->
<!--                    </td>-->
<!--                    <td class="text-center">-->
<!--                      {{ Helpers.formatarValor(converteEmbalagemValor(item.qtde)) }}-->
<!--                    </td>-->
<!--                    <td class="text-center">-->
<!--                      {{ Helpers.formatarValor(converteEmbalagemValor(item.qtde_pendente)) }}-->
<!--                    </td>-->
<!--                    <td class="text-right">-->
<!--                      <template v-if="embalagemMasterAtivada">-->
<!--                        {{ Helpers.formatarValorMonetario(item.multiplo_compra * item.punit) }}-->
<!--                      </template>-->
<!--                      <template v-else>-->
<!--                        {{ Helpers.formatarValorMonetario(item.punit) }}-->
<!--                      </template>-->
<!--                    </td>-->
<!--                    <td class="text-right">-->
<!--                      {{-->
<!--                        Helpers.formatarValorMonetario(item.total_compra)-->
<!--                      }}-->
<!--                    </td>-->
<!--                    <td class="text-right">-->
<!--                      <template v-if="embalagemMasterAtivada">-->
<!--                        {{ Helpers.formatarValorMonetario(item.multiplo_compra * item.punitant) }}-->
<!--                      </template>-->
<!--                      <template v-else>-->
<!--                        {{ Helpers.formatarValorMonetario(item.punitant) }}-->
<!--                      </template>-->
<!--                    </td>-->
<!--                    <td-->
<!--                      class="text-center"-->
<!--                      v-if="parseFloat(item.indicador_preco) > 0"-->
<!--                    >-->
<!--                      <v-icon-->
<!--                        :title="-->
<!--                          Helpers.formatarValor(item.indicador_preco) +-->
<!--                          '%'-->
<!--                        "-->
<!--                        color="red darken-2"-->
<!--                      >mdi-arrow-up</v-icon-->
<!--                      >-->
<!--                    </td>-->
<!--                    <td-->
<!--                      class="text-center"-->
<!--                      v-else-if="parseFloat(item.indicador_preco) < 0"-->
<!--                    >-->
<!--                      <v-icon-->
<!--                        :title="-->
<!--                          Helpers.formatarValor(item.indicador_preco) +-->
<!--                          '%'-->
<!--                        "-->
<!--                        color="green darken-2"-->
<!--                      >mdi-arrow-down</v-icon-->
<!--                      >-->
<!--                    </td>-->
<!--                    <td v-else>&nbsp;</td>-->
<!--                    <td class="text-center">-->
<!--                      <div-->
<!--                        class="lead_time_ok"-->
<!--                        v-if="parseInt(item.atraso) < 0"-->
<!--                      >-->
<!--                        {{ Math.abs(item.atraso) }}-->
<!--                      </div>-->
<!--                      <div v-if="parseInt(item.atraso) === 0">-->
<!--                        {{ Math.abs(item.tempo_entrega) }}-->
<!--                      </div>-->
<!--                      <div-->
<!--                        class="lead_time_atraso"-->
<!--                        v-if="parseInt(item.atraso) > 0"-->
<!--                      >-->
<!--                        {{ item.atraso }} atraso-->
<!--                      </div>-->
<!--                    </td>-->
<!--                  </tr>-->
<!--                </template>-->
<!--              </v-data-table>-->
<!--            </v-flex>-->
<!--          </v-layout>-->
<!--        </v-card>-->
<!--      </v-dialog>-->
<!--    </v-layout>-->

<!--    <v-layout justify-center>-->
<!--      <v-dialog-->
<!--        v-model="dialogVendas"-->
<!--        fullscreen-->
<!--        hide-overlay-->
<!--        transition="dialog-bottom-transition"-->
<!--        class="modal_margin"-->
<!--      >-->
<!--        <v-card>-->
<!--          <v-toolbar dark color="#042333">-->
<!--            <v-btn icon dark @click="dialogVendas = false">-->
<!--              <v-icon>mdi-close</v-icon>-->
<!--            </v-btn>-->
<!--            <v-toolbar-title>Detalhamento das Vendas</v-toolbar-title>-->

<!--            <converter-embalagem class="ml-3" />-->
<!--          </v-toolbar>-->
<!--          <v-layout style="padding: 10px 10px 0px 10px">-->
<!--            <v-flex xs12 class="text-lg-left">-->
<!--              <div style="display: flex; margin-bottom: 10px">-->
<!--                <h4>-->
<!--                  {{ detalhesProduto.idproduto }} - -->
<!--                  {{ detalhesProduto.descricao_produto }}-->
<!--                </h4>-->
<!--                <v-spacer />-->
<!--                <h4 style="color: black; text-align: right">-->
<!--                  Total de Saídas:-->
<!--                  {{ Helpers.formatarValor(converteEmbalagemValor(total_movimentos)) }}-->
<!--                </h4>-->
<!--              </div>-->
<!--            </v-flex>-->
<!--          </v-layout>-->

<!--          <v-card v-model="referenciaSelecionada" centered style="box-shadow: 0 0 0; border: 1px solid rgba(0,0,0, .1)">-->
<!--            <v-tabs color="primary" v-model="vselect_ref" centered>-->
<!--              <v-tab style="font-size: 9pt;"-->
<!--                     centered-->
<!--                     v-for="referencia in analiseProduto.referencia"-->
<!--                     :key="referencia"-->
<!--                     :items="analiseProduto.referencia"-->
<!--                     :href="`#${referencia}`"-->
<!--                     @click="detalhamentoVendasGrupo(detalhesProduto.idproduto, referencia)"-->
<!--              >-->
<!--                {{ mesData[parseInt(referencia.substring(0, 2)) -1]}}/{{referencia.substring(3)}}-->
<!--              </v-tab>-->
<!--            </v-tabs>-->
<!--            <v-spacer></v-spacer>-->
<!--          </v-card>-->
<!--          &lt;!&ndash; <v-layout style="padding: 10px 10px 0px 10px">-->
<!--            <v-select-->
<!--              v-if="analiseProduto.referencia"-->
<!--              label="Período de Referência"-->
<!--              v-model="vselect_ref"-->
<!--              outlined-->
<!--              dense-->
<!--              style="max-width: 300px"-->
<!--              :items="analiseProduto.referencia"-->
<!--            ></v-select>-->
<!--            <v-btn-->
<!--              color="#043554"-->
<!--              @click="-->
<!--                detalhamentoVendasGrupo(detalhesProduto.idproduto, vselect_ref)-->
<!--              "-->
<!--              class="ml-5"-->
<!--            >-->
<!--              <h4 style="color: #fff">Buscar</h4>-->
<!--            </v-btn>-->
<!--            <v-spacer></v-spacer>-->
<!--            <h4>-->
<!--              Total de Saídas Teste: {{ Helpers.formatarValor(total_movimentos) }}-->
<!--            </h4>-->
<!--          </v-layout> &ndash;&gt;-->
<!--          <v-layout style="padding: 10px 10px 0px 10px">-->
<!--            <v-flex xs12>-->
<!--              <v-data-table-->
<!--                :headers="headersTabelaDetalhesMovimentos"-->
<!--                :items="itensTabelaDetalhesMovimentos"-->
<!--                :fixed-header="true"-->
<!--                :items-per-page="9999"-->
<!--                id="detalhamentoVendas"-->
<!--                class="elevation-0 table-full-screen"-->
<!--              >-->
<!--                <template v-slot:item.qtde="{item}">-->
<!--                  {{Helpers.formatarValor(converteEmbalagemValor(item.qtde))}}-->
<!--                </template>-->
<!--                <template v-slot:item.filial="{item}">-->
<!--                  Filial {{item.filial}} - {{item.nome_fantasia}}-->
<!--                </template>-->
<!--              </v-data-table>-->
<!--            </v-flex>-->
<!--          </v-layout>-->
<!--        </v-card>-->
<!--      </v-dialog>-->
<!--    </v-layout>-->
<!--    <v-layout> </v-layout>-->

    <!-- Modal de Herança -->
    <v-layout justify-center>
      <v-dialog
        v-model="dialogHeranca"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="#042333" style=" ;">
            <v-btn
              icon
              dark
              @click="
                dialogHeranca = false;
                pesquisaProduto = '';
                qtdeAjustePorDialogHeranca = '';
                aumentarPercentual = '0';
              "
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Herança do Produto</v-toolbar-title>
          </v-toolbar>
          <v-layout style="padding: 15px 0 0 15px">
            <v-flex xs6>
              <v-autocomplete
                v-model="selects.produtos.value"
                :items="selects.produtos.items"
                item-value="idproduto"
                item-text="descricao_produto"
                label="Selecione o produto do qual será herdado"
                id="pesquisaProdutoHeranca"
                height="10"
                outlined
                clearable
                class="mr-5"
                chips
                :messages="['Produto herdado irá ficar como fora de linha.']"
                @keyup="buscarProdutosAposUmTempo()"
                @change="buscarDadosGraficoPrimeiroSemestre()"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs5 v-show="selects.produtos.value">
              <v-select
                v-model="selects.tiposHeranca.value"
                :items="selects.tiposHeranca.items"
                label="Selecione o Tipo de Herança*"
                item-text="tipo"
                item-value="id"
                height="10"
                chips
                outlined
                @change="
                  buscarDadosGraficoPrimeiroSemestre();
                  mudouTipoHeranca();
                "
              ></v-select>
            </v-flex>
            <v-flex xs1 class="ml-5 mt-2">
              <v-btn color="primary" @click="setProdutosHeranca()">
                <h4 style="color: #fff">Salvar</h4>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout style="padding: 0 15px 0 15px">
            <v-flex xs12>
              <div class="texto-descritivo fonte-pequena">
                <p>
                  <span>Lançamento:</span> herda o comportamento de saídas no
                  período de lançamento do produto.
                </p>
                <p>
                  <span>Contínua:</span> herda o comportamento de saídas no
                  período atual.
                </p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout
            v-if="selects.tiposHeranca.value == 1 && selects.produtos.value"
            style="padding: 20px 15px 0 15px"
          >
            <v-flex xs8>
              <h3>
                Saídas do 1° semestre do produto {{ selects.produtos.value }}
              </h3>
              <p>
                Período:
                <span v-if="infoDadasGrafico.data_ini"
                >{{ infoDadasGrafico.data_ini }} -
                  {{ infoDadasGrafico.data_fim_grafico }}</span
                >
                <span v-else>sem dados</span>
              </p>
              <ChartSaidasProduto
                :dados="dadosGraficoPrimeiroSemestre"
                style="height: 200px"
              />
            </v-flex>
            <v-flex xs4 class="ml-6 mr-3">
              <v-row>
                <v-col class="pa-0" cols="12" xs="12">
                  <h3 v-if="!detalhesProduto.id_fator_atuacao">
                    Deseja aplicar percentual na Projeção de vendas?
                  </h3>
                  <h3 v-else>
                    Deseja editar o percentual na Projeção de vendas?
                  </h3>
                  <v-radio-group v-model="aumentarPercentual" row>
                    <v-radio label="Sim" value="1"></v-radio>
                    <v-radio label="Não" value="0"></v-radio>
                  </v-radio-group>
                  <v-text-field
                    v-show="
                      aumentarPercentual == 1 ||
                      detalhesProduto.id_fator_atuacao
                    "
                    :disabled="aumentarPercentual == 0"
                    outlined
                    v-model="dataLimiteAjuste"
                    label="Data Limite"
                    type="date"
                    :error-messages="errorDataLimite"
                  ></v-text-field>
                </v-col>
                <v-col
                  class="pa-0"
                  cols="7"
                  xs="7"
                  v-show="
                    aumentarPercentual == 1 || detalhesProduto.id_fator_atuacao
                  "
                >
                  <v-select
                    outlined
                    :disabled="aumentarPercentual == 0"
                    v-model="tipoAjustePorDialogHeranca"
                    :items="selects.tipoAjuste.items"
                    label="Selecione o Tipo de Ajuste*"
                    item-value="id"
                    item-text="tipo"
                  ></v-select>
                </v-col>
                <v-col
                  class="pa-0"
                  cols="5"
                  xs="5"
                  v-show="
                    aumentarPercentual == 1 || detalhesProduto.id_fator_atuacao
                  "
                >
                  <v-text-field
                    outlined
                    :disabled="aumentarPercentual == 0"
                    class="ml-5"
                    v-model="qtdeAjustePorDialogHeranca"
                    label="Informe o Percentual"
                    placeholder="Exemplo: 50"
                    :error="
                      tipoAjustePorDialogHeranca == 2 &&
                      qtdeAjustePorDialogHeranca == 100
                        ? true
                        : false
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-flex>
          </v-layout>
          <v-layout
            v-if="selects.tiposHeranca.value == 1 && selects.produtos.value"
            style="padding: 0 15px 0 15px"
          >
            <v-flex
              xs4
              class="texto-descritivo block"
              style="text-align: center"
            >
              <p>
                <span>Média 3 Meses:</span>
                {{
                  Helpers.formatarValor(infoProjecaoEMedias.media_trimestral)
                }}
              </p>
            </v-flex>
            <v-flex
              xs4
              class="texto-descritivo block"
              style="text-align: center"
            >
              <p>
                <span>Média 6 Meses:</span>
                {{ Helpers.formatarValor(infoProjecaoEMedias.media_semestral) }}
              </p>
            </v-flex>
            <v-flex
              xs4
              class="texto-descritivo block"
              style="text-align: center"
            >
              <p>
                <span>Projeção de vendas:</span>
                {{ Helpers.formatarValor(infoProjecaoEMedias.projecao) }}
              </p>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Modal de embalagem -->
    <v-layout justify-center>
      <v-dialog
        v-model="dialogEmbalagem"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="#042333" style=" ;">
            <v-btn icon dark @click="fecharDialogEmbalagem()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Cadastro Embalagem Padrão</v-toolbar-title>
          </v-toolbar>
          <v-layout style="padding: 0px 3px 0px 3px">
            <v-data-table
              :headers="headersEmbalagem"
              :items="dessertsEmbalagem"
              :height="320"
              :fixed-header="true"
              class="elevation-0 table-full-screen table-full-screen-responsiva"
              style="width: 100%"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Embalagens de Produtos</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                </v-toolbar>
              </template>
              <template v-slot:item.qtunit="{ item }">
                {{ parseFloat(item.qtunit) | numeral("0.0000") }}
              </template>
              <template v-slot:item.user_cadastro="{ item }">
                <span v-if="item.user_cadastro && item.emb_padrao == 'S'">
                  {{ item.user_cadastro }}
                </span>
                <span v-else>-</span>
              </template>
              <template v-slot:item.log_data="{ item }">
                <span v-if="item.log_data && item.emb_padrao == 'S'">
                  {{ item.log_data }}
                </span>
                <span v-else>-</span>
              </template>
              <template v-slot:item.emb_padrao="{ item }">
                <v-checkbox
                  :input-value="item.emb_padrao == 'S' ? true : false"
                  @click="alterarEmbalagem(item)"
                ></v-checkbox>
              </template>
            </v-data-table>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import GraficoMovimentacoesEstoqueProduto from "@/components/produto/detalhes/grafico/GraficoMovimentacoesEstoqueProduto.vue";
import { mapGetters } from "vuex";
import CompraAPI from "./../../api/compra";
import UtilitariosAPI from "./../../api/utilitarios";
import ChartSaidasProduto from "./ChartSaidasProduto";
import detalhamentoEstoque from "./detalhesProduto/DetalhamentoEstoque.vue";
import dialogSimilares from "./detalhesProduto/Similares";
import RaioX from "./raio-x-produto/RaioXProduto";
import loteMinimo from "./detalhesProduto/LoteMinimo";
import FatorAtuacao from "./detalhesProduto/FatorAtuacao.vue";
import sysInputFormatador from "../utils/InputFormatadorDeValor.vue";
import $axios from '../../api/api.js';
import ImgProdutoDialog from "../produto/ImagemProdutoDialog";
import TextFieldFormatadorDeValor from "../utils/TextFieldFormatadorDeValor.vue"
import MixinCompra from "./MixinCompra";
import ConverterEmbalagem from "./Embalagem/ConverterEmbalagem";
import TendenciaUltimasEntradas from "./detalhesProduto/tendenciasUltimasEntradas/Index.vue";
import {FILIAL_TODAS} from "../utils/FilialGrupo.js";
import ComparativoPreco from "./detalhesProduto/ComparativoPreco/Index.vue";
import CloseUp from "./detalhesProduto/CloseUp/Index.vue";
import UltimasVendasProduto from "@/components/produto/detalhes/UltimasVendas/Index.vue";
import EstoqueSeguranca from './detalhesProduto/EstoqueSeguranca/EstoqueSeguranca.vue';
import UltimasCompras from '@/components/produto/detalhes/UltimasCompras/Index';
import Transferencia from './detalhesProduto/Transferencia/Transferencia.vue';
import NivelEstoqueProgressCircular from "@/components/produto/detalhes/NivelEstoqueProgressCircular.vue";
import Legenda from "@/components/produto/detalhes/Legenda.vue";
import AnaliseDrpEstoqueFiliais from "@/components/produto/DRP/AnaliseEstoqueFiliais/Index.vue";
import {arrayColumn} from "@/helpers";
import ComparacaoProdutos from '@/components/produto/DemandaCombinada/ComparacaoProdutos/Index.vue';
import ProjecaoVendasParametrizavel from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/Index.vue";
import DashComparandoEvolucaoDePrecoDeCompras from './detalhesProduto/DashComparandoEvolucaoDePrecoDeCompras/Index.vue';
import Heranca from "@/components/produto/detalhes/Acoes/Heranca/Index";
import FormatarMoeda from "@/components/utils/FormatarMoeda.vue";
import LegendaTotalGeralEPorFilial from "@/components/produto/detalhes/CamposPersonalizados/LegendaTotalGeralEPorFilial.vue";
import MixinNivelServico from "@/components/compra/detalhesProduto/MixinNivelServico";
import {
  descricao_index_tipo_projecao_vendas
} from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/Simulacao/Helpers";
import DialogModeloPrevisaoAtual from "@/components/produto/detalhes/DialogModeloPrevisaoAtual.vue";

export default {
  name: "DetalhesProduto",
  mixins: [MixinCompra, MixinNivelServico],
  props: {
    atualizarP: {
      type: [Number, String]
    },
    elevationHidden: {
      type: Boolean,
      default: false
    },
    produto: {
      type: Object,
      required: false
    },
    cardSelecionado: Object
  },
  components: {
    DialogModeloPrevisaoAtual,
    LegendaTotalGeralEPorFilial,
    AnaliseDrpEstoqueFiliais,
    Legenda,
    NivelEstoqueProgressCircular,
    UltimasVendasProduto,
    TendenciaUltimasEntradas,
    ConverterEmbalagem,
    GraficoMovimentacoesEstoqueProduto,
    ChartSaidasProduto,
    detalhamentoEstoque,
    RaioX,
    loteMinimo,
    FatorAtuacao,
    dialogSimilares,
    sysInputFormatador,
    ImgProdutoDialog,
    TextFieldFormatadorDeValor,
    ComparativoPreco,
    CloseUp,
    EstoqueSeguranca,
    UltimasCompras,
    Transferencia,
    ComparacaoProdutos,
    DashComparandoEvolucaoDePrecoDeCompras,
    ProjecaoVendasParametrizavel,
    Heranca,
    FormatarMoeda
  },

  data() {
    return {
      click_bar: null,
      vselect_id: "",
      vselect_id_tipo: "3",
      vselect_ref: "",
      vtext_id: "",
      mesData: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ],

      sel_dados: [
        { id: "S", name: "SIM" },
        { id: "N", name: "NÃO" },
      ],

      sel_dados_tipo: "",

      selects: {
        filial: {
          items: [{ filial: FILIAL_TODAS.ID, descricao: FILIAL_TODAS.DESCRICAO }],
          value: FILIAL_TODAS.ID,
        },
        produtoForn: {
          items: [
            { id: 1, descricao: "SOMENTE ITEM CORRENTE" },
            { id: 2, descricao: "TODOS OS ITENS DO FORNECEDOR" },
          ],
          value: 1,
        },
        tipoAjuste: {
          items: [
            { id: 1, tipo: "Aumento" },
            { id: 2, tipo: "Redução" },
          ],
          value: "",
        },
        produtos: {
          items: [],
          value: 0,
        },
        tiposHeranca: {
          items: [
            { id: 1, tipo: "Lançamento" },
            { id: 2, tipo: "Continua" },
          ],
          value: 0,
        },
      },

      status: "",
      dialogRessuprimento: false,
      dialogDetalhes: false,
      dialog: false,
      // dialogUltimas: false,
      dialogVendas: false,
      dialogFatorAtuacao: false,
      dialogHeranca: false,
      dialogEmbalagem: false,
      referenciaSelecionada: null,

      headersTabelaUltimas: [
        { text: "Razão Social", value: "ordem_compra" },
        { text: "Filial", value: "filial" },
        { text: "Pedido", value: "ordem_compra" },
        { text: "Item", value: "item" },
        { text: "Produto", value: "produto" },
        { text: "Dt. Solicitação", value: "data_solicitacao" },
        { text: "Dt. Previsão", value: "data_previsao" },
        { text: "Dt. Entrada", value: "data_entrega" },
        // { text: "Qtde. Faturada", value: "qtde_faturada" },
        { text: "Dt. Faturamento", value: "data_faturamento" },
        {
          text: "UND",
          value: "unidade_compra",
        },
        { text: "Qtde.", value: "qtde" },
        { text: "Qtde. Pendente", value: "qtde_pendente" },
        { text: "Valor Unit.", value: "pcompra" },
        { text: "Total", value: "total_compra" },
        { text: "Valor Unitário Ant.", value: "pcompraant" },
        { text: "Indicador", value: "indicador_preco" },
        { text: "Tempo entrega dia(s)", value: "atraso" },
      ],

      // headersTabelaDetalhesMovimentos: [
      //   { text: "Produto", value: "produto" },
      //   { text: "Filial", value: "filial" },
      //   { text: "Pedido", value: "idconsumo" },
      //   { text: "Emissao", value: "emissao" },
      //   { text: "Horário", value: "horariomov" },
      //   { text: "Quantidade", value: "qtde" },
      // ],

      headersDetalhamentoEstoqueGrupo: [
        { text: "Filial", value: "filial" },
        { text: "Estoque", value: "estoque" },
        { text: "Estoque de Segurança", value: "estoque" },
        { text: "Ponto Pedido", value: "ponto_pedido" },
        { text: "Estoque Máximo", value: "estoque_maximo" },
        { text: "Cobertura Estoque", value: "cobertura_estoque" },
        { text: "Projeção de vendas", value: "consumo_medio_mensal" },
      ],

      headersEmbalagem: [
        { text: "Filial", value: "filial" },
        { text: "Id Produto", value: "idproduto" },
        { text: "Descrição Produto", value: "descricao_produto" },
        { text: "Fator Conversão", value: "qtunit" },
        { text: "Unidade", value: "unidade" },
        { text: "Embalagem", value: "embalagem" },
        { text: "Usuário Cadastro", value: "user_cadastro" },
        { text: "Data Cadastro", value: "log_data" },
        { text: "Embalagem Padrão", value: "emb_padrao" },
      ],
      // itensTabelaDetalhesMovimentos: [],
      produtos: [],
      dessertsEmbalagem: [],
      // total_movimentos: 0,
      atualizarProdutos: 0,
      fatorAtuacaoPorFornecedor: true,
      qtdeAjuste: "",
      dataLimiteAjuste: "",

      pesquisaProduto: "",
      dadosGraficoPrimeiroSemestre: [],
      infoProjecaoEMedias: {},
      infoDadasGrafico: {},
      qtdeAjustePorDialogHeranca: "",
      aumentarPercentual: "0",
      tipoAjustePorDialogHeranca: 0,

      coberturaManualProduto: 0,
      ativo_estetico_por_pp: localStorage.estetico_por_pp === 'S',
      dialog_modelo_previsao_atual: false,
      dialog_tipo_projecao_venda: false,
    };
  },

  created() {
    this.status = this.Helpers.buscarObjetoStatus(this.detalhesProduto.status);
    this.buscarFiliais();
  },

  mounted() {
    this.selecionarDadosFatorAtuacao();
    this.vselect_id = this.detalhesProduto.ressuprimento_manual;
    this.vtext_id = this.detalhesProduto.ressuprimento_manual_dias;
    this.refazerAtividade();
    this.getCoberturaManualProduto();
  },

  computed: {
    ...mapGetters({
      fornecedorCompra: "fornecedor/getFornecedor",
      compradorCompra: "fornecedor/getComprador",
      detalhesProduto: "detalhe_produto/getProduto",
      detalhesUltimaCompra: "detalhe_produto/getUltimaCompra",
      analiseProduto: "detalhe_produto/getAnalise",
      ultimasCompras: "detalhe_produto/getUltimasCompras",
      grupoCompra: "usuario/getGrupoCompras",
      filialCompra: "usuario/getFilialCompras",
      activityLog: "activityLog/getLog",
      configuracoes: "configuracoes/carrinho",
      embalagemMasterAtivada: "EmbalagemTelaDeCompras/getEmbalagemMaster",
      COUNT_ABRIR_DETALHES_PRODUTO: "tabelaProduto/getCountAbrirDetalhesProduto",
    }),
    sazonalidadeDataInicial() {
      if (this.detalhesProduto.data_inicial.split(',').length > 1) {
        return this.detalhesProduto.data_inicial.substring(0,10) + '(+' + (this.detalhesProduto.data_inicial.split(',').length - 1) + ')';
      } else {
        return this.detalhesProduto.data_inicial.substring(0,10);
      }
    },
    sazonalidadeDataFinal() {
      if (this.detalhesProduto.data_final.split(',').length > 1) {
        return this.detalhesProduto.data_final.substring(0,10) + '(+' + (this.detalhesProduto.data_final.split(',').length - 1) + ')';
      } else {
        return this.detalhesProduto.data_final.substring(0,10);
      }
    },
    parametrosChartMovimentacoesEstoque() {
      if (!this.detalhesProduto.idproduto) {
        return {};
      }

      const filial = (this.selects.filial.value >= 0) ? this.selects.filial.value : this.filialCompra

      return {
        produto: this.detalhesProduto.idproduto,
        produtos: this.detalhesProduto.produtos,
        fornecedor: this.detalhesProduto.idfornecedor,
        grupo: this.detalhesProduto.id_grupo,
        filial,
        produto_eh_combinacao: this.detalhesProduto.produto_eh_combinacao ? 'S' : 'N',
      };
    },
    exibirFatorAtuacao() {
      let exibir = localStorage.getItem("fator_atuacao");
      exibir = exibir == "N" ? false : true;
      return exibir;
    },
    errorDataLimite() {
      let error = "";

      if (
        this.dataLimiteAjuste &&
        this.dataLimiteAjuste != 7 &&
        this.dataLimiteAjuste != 30
      ) {
        // abaixo eu transformo as datas em numeros inteiro para poder fazer comparações
        let a = new Date().toLocaleDateString().split("/");
        let dataAtual = a[2] + a[1] + a[0];

        let b = this.dataLimiteAjuste.split("-");
        let dataInformada = b[0] + b[1] + b[2];

        if (parseInt(dataInformada) <= parseInt(dataAtual))
          error = "Informe uma data maior que a de Hoje";
      }

      return error;
    },
    tituloStatusProduto() {
      let descricaoStatus = '';
      const {status_produto} = this.detalhesProduto;

      switch (status_produto) {
        case 'Excesso':
          descricaoStatus = "Saldo de estoque acima do Estoque Máximo";
          break;
        case 'Nível Adequado':
          descricaoStatus = "Saldo de estoque maior que o Ponto de Pedido e menor ou igual ao Estoque Máximo";
          break;
        case 'Baixa Exposição a Ruptura':
          descricaoStatus = "Saldo estoque menor ou igual ao Ponto de Pedido e cobertura de estoque maior ou igual ao Lead time";
          break;
        case 'Alta Exposição a Ruptura':
          descricaoStatus = "Saldo de estoque menor ou igual ao Ponto de Pedido e cobertura de estoque menor que o Lead time";
          break;
        case 'Ruptura':
          descricaoStatus = "Saldo de estoque igual a 0";
          break;
      }

      return descricaoStatus;
    },
    formatarBadgeTipoProjecao () {
      if (this.detalhesProduto.tipo_projecao_vendas === 'padrao_systock') {
        return { backgroundColor: '#F3F8FF', color: '#245AE5' };
      }

      return { backgroundColor: '#FFF3EC', color: '#FF8040' };
    },
    tipoProjecaoVendas() {
      const v = this.detalhesProduto ? this.detalhesProduto.tipo_projecao_vendas : null;
      return v != null && v !== "" ? String(v) : "padrao_systock";
    },
    truncarTipoProjecaoVendas() {
      return this.tipoProjecaoVendas.length > 16
    },
    formatarAlturaGrafico() {
      let offset = 405

      if (this.detalhesUltimaCompra && this.detalhesUltimaCompra.ordem_compra) {
        offset = 423
      }

      if (this.tipoProjecaoVendas !== 'padrao_systock') {
        offset = 403
      }

      if (
        this.detalhesUltimaCompra
        && this.detalhesUltimaCompra.ordem_compra
        && this.tipoProjecaoVendas !== 'padrao_systock'
      ) {
        offset = 418
      }

      return { height: `calc(100vh - ${offset}px)` }
    },
  },

  watch: {
    COUNT_ABRIR_DETALHES_PRODUTO() {
      this.dialogDetalhes = true;
    },
    detalhesProduto() {
      this.status = this.Helpers.buscarObjetoStatus(
        this.detalhesProduto.status
      );
      this.vselect_id = this.detalhesProduto.ressuprimento_manual;
      this.vtext_id = this.detalhesProduto.ressuprimento_manual_dias;

      if (this.grupoCompra == 0) {
        this.buscarFiliais();
      }

      this.selecionarDadosFatorAtuacao();
      this.$store.dispatch("tabelaProduto/setProdutoUltimoClick", this.detalhesProduto);
      this.getCoberturaManualProduto();

      if (this.filialCompra == 0) {
        this.selects.filial.value = FILIAL_TODAS.ID;
      }
    },
    // dialogVendas: function () {
    //   if (this.dialogVendas) {
    //     this.itensTabelaDetalhesMovimentos = [];
    //   }
    //
    //   const length = this.analiseProduto.referencia.length;
    //
    //   if (length) {
    //     this.vselect_ref = this.analiseProduto.referencia[length - 1];
    //
    //     this.detalhamentoVendasGrupo(
    //       this.detalhesProduto.idproduto,
    //       this.vselect_ref
    //     );
    //   } else {
    //     this.vselect_ref = "";
    //   }
    // },
    activityLog() {
      this.refazerAtividade();
    },

  },

  methods: {
    atualizarDetalhesProdutosAposAlterarUltimaCompras() {
      this.$store.dispatch("detalhe_produto/setAtualizarDetalhes");
    },
    atualizarDetalhesProdutosAposAlterarLoteMinimo() {
      this.$emit('atualizar-produtos-total');
      this.$store.dispatch("detalhe_produto/setAtualizarDetalhes");
    },
    converteEmbalagemValor(valor) {
      const multiploCompra = this.detalhesProduto.multiplo_compra || 1;

      if (this.detalhesProduto.tipo_fator_conversao === 'D') {
        return this.embalagemMasterAtivada ? (valor / multiploCompra) : valor;
      }

      return this.embalagemMasterAtivada ? (valor * multiploCompra) : valor;
    },
    alterarSelectRessuprimento() {
      var qtdSelecionados = JSON.parse(localStorage.itemSelect).length;
      if (qtdSelecionados >= 1) {
        this.sel_dados_tipo = [
          { id: "2", name:'TOTAL DE (' + qtdSelecionados + ') ITENS SELECIONADOS'},
          { id: "3", name: "TODOS OS ITENS DO FORNECEDOR" }
        ];
        this.vselect_id_tipo = '2';
      } else {
        this.sel_dados_tipo = [
          { id: "1", name: "SOMENTE ITEM CORRENTE" },
          { id: "3", name: "TODOS OS ITENS DO FORNECEDOR" },
        ];
        this.vselect_id_tipo = '1';
      }
    },
    refazerAtividade() {
      const FUNCTION = this.activityLog.function;

      if (typeof this[FUNCTION] == "function") {
        this[FUNCTION](this.activityLog.properties.attributes);
      }
    },

    // fecharDialogUltimasCompra() {
    //   this.dialogUltimas = false;
    //   this.$store.dispatch("activityLog/resetLog");
    // },

    getCoberturaManualProduto() {
      this.coberturaManualProduto = this.detalhesProduto.cobertura_manual_produto;
    },

    atualizarCoberturaManualProduto(valorCobertura, detalhes) {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        coberturaManualProduto: Number(valorCobertura),
        idproduto: detalhes.idproduto,
        idgrupo: detalhes.id_grupo,
        produto_eh_combinacao: this.detalhesProduto.produto_eh_combinacao
      };
      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.atualizarCoberturaManualProduto(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            this.coberturaManualProduto = valorCobertura;
            this.$emit("atualizar-produtos-total");
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    fecharDialogEmbalagem() {
      this.dialogEmbalagem = false;
      this.$store.dispatch("activityLog/resetLog");
    },

    alterarEmbalagem(item) {
      // setTimeout para evitar chamadas seguidas ao mesmo tempo
      clearTimeout(this.interval);
      this.interval = setTimeout(() => {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          codauxiliar: item.codauxiliar,
          filial: item.filial,
          idproduto: item.idproduto,
          grupo: this.grupoCompra,
          emb_padrao: item.emb_padrao == "S" ? "N" : "S",
          user: localStorage.getItem("id"),
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          CompraAPI.setEmbalagem(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.getEmbalagem();

              this.atualizarProidprodutodutos += parseInt(this.atualizarP) + 1;
              this.$emit("atualizarProdutos", this.atualizarProdutos + "-");
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }, 100);
    },

    getEmbalagem(produto = {}) {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: produto.grupo || this.grupoCompra,
        idproduto: produto.idproduto || this.detalhesProduto.idproduto,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getEmbalagem(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.dialogEmbalagem = true;
            this.dessertsEmbalagem = response.data.embalagem;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    mudouTipoHeranca() {
      if (this.selects.tiposHeranca.value == 2) {
        this.aumentarPercentual = "0";
      }

      this.dataLimiteQtdeAjusteETipoAjusteHeranca();
    },

    abrirDialogFatorAtuacao() {
      this.dialogFatorAtuacao = true;
      this.dataLimiteAjuste = this.detalhesProduto.data_limite_fa;
    },

    buscarDadosGraficoPrimeiroSemestre() {
      if (this.selects.tiposHeranca.value == 1) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          idproduto: this.selects.produtos.value,
          grupo: this.grupoCompra,
          filial: this.filialCompra,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          CompraAPI.getSaidasProdutos(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.dadosGraficoPrimeiroSemestre = response.data.dados;
              this.infoProjecaoEMedias = response.data.projecaoEMedias;
              this.infoDadasGrafico = response.data.infoDatas;
            })
            .catch(() => {
              this.$store.dispatch("loading/habilitarLoading", false);
              this.Helpers.logout();
            })
        );
      }
    },

    abrirDialogHeranca() {
      this.pesquisaProduto = "";
      this.buscarProdutosHeranca();
      this.selects.produtos.value = this.detalhesProduto.id_heranca;
      this.selects.tiposHeranca.value = this.detalhesProduto.tipo_heranca;
      this.buscarDadosGraficoPrimeiroSemestre();

      this.dataLimiteQtdeAjusteETipoAjusteHeranca();
    },

    dataLimiteQtdeAjusteETipoAjusteHeranca() {
      if (!this.detalhesProduto.data_limite_fa) {
        const data = new Date();
        const mes =
          data.getMonth() + 2 < 10
            ? "0" + (data.getMonth() + 2)
            : data.getMonth() + 2;

        this.dataLimiteAjuste =
          data.getFullYear() + "-" + mes + "-" + data.getDate();
        this.qtdeAjustePorDialogHeranca = "";
        this.tipoAjustePorDialogHeranca = 0;
      } else {
        this.dataLimiteAjuste = this.detalhesProduto.data_limite_fa;
        this.qtdeAjustePorDialogHeranca = this.qtdeAjuste;
        this.tipoAjustePorDialogHeranca = this.selects.tipoAjuste.value;
      }
    },

    setProdutosHeranca() {
      if (
        (this.selects.produtos.value &&
          this.selects.tiposHeranca.value > 0 &&
          ((this.aumentarPercentual == 1 &&
              this.qtdeAjustePorDialogHeranca > 0 &&
              this.errorDataLimite == "" &&
              this.dataLimiteAjuste != "" &&
              this.tipoAjustePorDialogHeranca != 0 &&
              ((this.tipoAjustePorDialogHeranca == 2 &&
                  this.qtdeAjustePorDialogHeranca < 100) ||
                this.tipoAjustePorDialogHeranca != 2)) ||
            this.aumentarPercentual == 0)) ||
        !this.selects.produtos.value
      ) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          grupo: this.grupoCompra,
          idproduto: this.detalhesProduto.idproduto,
          idprodutoHeranca: this.selects.produtos.value
            ? this.selects.produtos.value
            : 0,
          tipo: this.selects.produtos.value
            ? this.selects.tiposHeranca.value
            : 0,
          data_percentual: this.dataLimiteAjuste,
          idfornecedor: this.detalhesProduto.idfornecedor,
          id_fa: this.detalhesProduto.id_fator_atuacao,
          tipoAjuste: this.tipoAjustePorDialogHeranca,
          qtde_ajuste_percentual:
            this.aumentarPercentual == 1 ? this.qtdeAjustePorDialogHeranca : 0,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          CompraAPI.setProdutosHeranca(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.dialogHeranca = false;
              this.qtdeAjustePorDialogHeranca = "";
              this.tipoAjustePorDialogHeranca = 0;

              this.$emit("atualizarTelaCompras", {
                idproduto: this.detalhesProduto.idproduto,
              });

              this.$emit("ocultarDetalhesProduto", true);
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      } else {
        alert("Informe TODOS os dados corretamente!");
      }
    },

    buscarProdutosAposUmTempo() {
      this.pesquisaProduto = document
        .getElementById("pesquisaProdutoHeranca")
        .value.toString();

      clearTimeout(this.interval);
      this.interval = setTimeout(() => {
        if (this.pesquisaProduto != "") this.buscarProdutosHeranca();
      }, 700);
    },

    buscarProdutosHeranca() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        ignorar: [this.detalhesProduto.idproduto],
        idproduto: this.detalhesProduto.id_heranca,
        pesquisaProduto: this.pesquisaProduto,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        UtilitariosAPI.getProdutosSobDemanda(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            this.dialogHeranca = true;
            this.selects.produtos.items = response.data.produtos;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    selecionarDadosFatorAtuacao() {
      if (
        this.detalhesProduto.percentual > 0 &&
        this.detalhesProduto.id_fator_atuacao
      ) {
        this.selects.tipoAjuste.value =
          this.detalhesProduto.fator_atuacao >= 1 ? 1 : 2;
        this.qtdeAjuste = this.detalhesProduto.percentual;
        this.dataLimiteAjuste = this.detalhesProduto.data_limite_fa;
      } else {
        this.selects.tipoAjuste.value = "";
        this.qtdeAjuste = "";
        this.dataLimiteAjuste = "";
      }
    },

    editarFatorAtuacao() {
      if (
        this.selects.tipoAjuste.value != "" &&
        this.qtdeAjuste != "" &&
        !(this.selects.tipoAjuste.value == 2 && this.qtdeAjuste == 100) &&
        this.dataLimiteAjuste != "" &&
        this.errorDataLimite == ""
      ) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          id_fa: this.detalhesProduto.id_fator_atuacao,
          fornOuProd: this.selects.produtoForn.value,
          idproduto: this.detalhesProduto.idproduto,
          idfornecedor: this.detalhesProduto.idfornecedor,
          grupo: this.grupoCompra,
          tipoAjuste: this.selects.tipoAjuste.value,
          qtdeAjuste: this.qtdeAjuste,
          data_limite: this.dataLimiteAjuste,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          CompraAPI.setFatorAtuacao(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.dialogFatorAtuacao = false;

              this.atualizarProdutos += parseInt(this.atualizarP) + 1;
              this.$emit("atualizarProdutos", this.atualizarProdutos);

              this.$emit("ocultarDetalhesProduto", true);
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      } else {
        if (this.selects.tipoAjuste.value == 2 && this.qtdeAjuste == 100) {
          alert("No ajuste tipo Redução a Qtde. Ajuste não pode ser 100%.");
        } else {
          alert(
            "ATENÇÃO!\nDados com * simboliza campos obrigatórios, informe-os."
          );
        }
      }
    },

    fechouDialogSimilares() {
      this.atualizarProdutos += parseInt(this.atualizarP) + 1;
      this.$emit("atualizarProdutos", this.atualizarProdutos);
      this.$emit("ocultarDetalhesProduto", true);

      this.$store.dispatch("activityLog/resetLog");
    },

    buscarFiliais() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.detalhesProduto.id_grupo,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getFiliais(headers, params)
          .then((response) => {
            const {token, filiais} = response.data
            localStorage.setItem("token", token);

            this.selects.filial.items = filiais.map( item => {
              if (item.nome_fantasia) {
                item.descricao = item.descricao + ' - ' + item.nome_fantasia
              }
              return item;
            });

            filiais.forEach((filial) => {
              this.selects.filial.items.push(filial);
            });

            this.selects.filial.items.push({filial: FILIAL_TODAS.ID, descricao: FILIAL_TODAS.DESCRICAO})

            if (this.filialCompra > 0) {
              this.selects.filial.value = this.filialCompra;
            } else {
              this.selects.filial.value = FILIAL_TODAS.ID;
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    // getUltimasComprasGrupo(produto) {
    //   const headers = this.Helpers.iniciarRequisicao();
    //
    //   const params = {
    //     produto: produto.idproduto || produto.produto,
    //     rows: 100,
    //     grupo: this.detalhesProduto.id_grupo,
    //     filial: this.filialCompra <= -1 ? 0 : this.filialCompra,
    //   };
    //
    //   this.$store.dispatch(
    //     "loading/addRequisicao",
    //     CompraAPI.getUltimasComprasGrupo(headers, params)
    //       .then((response) => {
    //         const token = response.data.token;
    //         localStorage.setItem("token", token);
    //
    //         this.dialogUltimas = true;
    //
    //         this.$store.dispatch("detalhe_produto/setUltimasCompras", {});
    //         this.$store.dispatch(
    //           "detalhe_produto/setUltimasCompras",
    //           response.data
    //         );
    //       })
    //       .catch(() => {
    //         this.Helpers.logout();
    //       })
    //   );
    // },

    // detalhamentoVendasGrupo(produto, ref) {
    //   const headers = this.Helpers.iniciarRequisicao();
    //
    //   const params = {
    //     produto: produto,
    //     referencia: ref,
    //     grupo: this.detalhesProduto.id_grupo,
    //     filialCompra: this.filialCompra <= -1 ? 0 : this.filialCompra,
    //   };
    //
    //   this.$store.dispatch(
    //     "loading/addRequisicao",
    //     CompraAPI.getDetalhesMovimentacaoGrupo(headers, params)
    //       .then((response) => {
    //         const token = response.data.token;
    //         localStorage.setItem("token", token);
    //
    //         this.itensTabelaDetalhesMovimentos = response.data.vendas.detalhes;
    //         this.total_movimentos = response.data.vendas.totais[0].total_saidas;
    //       })
    //       .catch(() => {
    //         this.$store.dispatch("loading/habilitarLoading", false);
    //         this.Helpers.logout();
    //       })
    //   );
    // },

    ajustarTempoRessuprimentoGrupo() {
      if (this.vselect_id === "S" && parseInt(this.vtext_id) === 0) {
        alert("Quantidade de dias deve ser maior que 0");
        return false;
      }

      if (this.vselect_id_tipo == 2 && localStorage.itemSelect == '[]') {
        this.vselect_id_tipo = '1';
      }

      const headers = this.Helpers.iniciarRequisicao();

      const produtosSelecionados = arrayColumn(JSON.parse(localStorage.itemSelect), 'idproduto');

      if (produtosSelecionados.length > 0) {
        this.vselect_id_tipo = 2;
      }

      const params = {
        fornecedor: this.detalhesProduto.idfornecedor,
        ressuprimento_manual: this.vselect_id,
        ressuprimento_qtde_dias: this.vtext_id,
        produto: this.detalhesProduto.idproduto,
        produtosSelecionados,
        tipo: this.vselect_id_tipo,
        grupo: this.detalhesProduto.id_grupo,
        filial: this.filialCompra,
        produto_eh_combinacao: this.detalhesProduto.produto_eh_combinacao,
      };

      this.dialogRessuprimento = false;

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.ajustarTempoRessuprimentoGrupo(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.cardSelecionado.metodo(this.fornecedorCompra.id);

            this.Helpers.atualizarTotaisGrupo(
              this.fornecedorCompra.id,
              this.grupoCompra,
              this.filialCompra,
              this.compradorCompra.id || 0,
              this.fornecedorCompra.idSegmento || 0
            );

            this.$emit("ocultarDetalhesProduto", true);
          })
          .catch(() => {
            this.$store.dispatch("loading/habilitarLoading", false);
            this.Helpers.logout();
          })
      );
    },

    mudarRessuprimentoManual(id) {
      if (id === "N") {
        this.vtext_id = 0;
      }
    },

    relatorio() {
      const token = localStorage.getItem("token");

      let url =
        "relatorio_fornecedor_tendencia?token=" +
        token +
        "&fornecedor=" +
        this.detalhesProduto.idfornecedor +
        "&produto=" +
        this.detalhesProduto.idproduto +
        "&grupo=" +
        this.grupoCompra;

      window.open($axios.defaults.baseURL + "/" + url, "_blank");
    },
    consumoDesconsiderado() {
      this.$emit('atualizarProdutos', Number(this.atualizarP) + 1);
    },
    aposSalvarHeranca() {
      this.$emit('atualizarTelaCompras', { idproduto: this.detalhesProduto.idproduto });
      this.$store.dispatch('detalhe_produto/setAtualizarDetalhes');
    },
    atualizarCobertura() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        produto: this.detalhesProduto.idproduto,
        fornecedor: this.detalhesProduto.idfornecedor,
        grupo: this.detalhesProduto.id_grupo,
        filial: parseInt(this.filialCompra),
        produto_eh_combinacao: this.detalhesProduto.produto_eh_combinacao ? 'S' : 'N'
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getDetalhesProdutoGrupo(headers, params)
          .then((response) => {
            const {token, produto, detalhe_ultima_compra, estoque_filiais, mediasSaidas} = response.data;
            localStorage.setItem("token", token);
            this.$store.dispatch("detalhe_produto/setProduto", produto);
            this.$store.dispatch("detalhe_produto/setUltimaCompra", detalhe_ultima_compra);
            this.$store.dispatch("detalhe_produto/setEstoqueFiliais", estoque_filiais);
            this.$store.dispatch("detalhe_produto/setAnalise", mediasSaidas);
            this.$emit("atualizar-produtos-total");
          })
          .catch(() => this.Helpers.logout())
      );
    },
    formatarTipoProjecaoVendas(tipo_projecao_vendas) {
      return descricao_index_tipo_projecao_vendas[tipo_projecao_vendas];
    }
  },
};
</script>


<style scoped>
.card {
  border-radius: 5px;
  padding: 2%;
  margin: 5px 1% 0% 0%;
}

.dot {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
}

.dot-square {
  height: 15px;
  width: 15px;
  border-radius: 2px;
  display: inline-block;
}

.text-color-systock {
  color: #042333;
}

.modal_margin {
  margin: 1% 0% 1% 1%;
  font-size: 13px;
}

.card_ressuprimento {
  font-size: 10px;
  color: #043554;
  padding-bottom: 25px;
}

.lead_time_ok {
  color: green;
}

.lead_time_atraso {
  color: red;
}

#icon-info {
  font-size: 1.1rem;
  margin-top: -8px;
}

.texto-descritivo p {
  margin: 0;
  padding: 2.5px;
  color: #222;
}

.texto-descritivo p span {
  font-weight: bold;
}

.fonte-pequena {
  font-size: 0.85rem;
}

.block {
  background: rgba(0, 0, 0, 0.15);
}

.altura-responsiva-fornecedor-produto {
  margin-top: 5px;
}
#detalhes-produto {
  padding: 0;
  margin-left: -20px;
  margin-right: -5px;
  margin-top: -32px;
}
#detalhe-produto {
  font-size: 16px;
  margin-top: -10px;
  display: flex;
}
#table-detalhes-produto {
  width: 100%;
  border-collapse: collapse;
}
#table-detalhes-produto tr td {
  border-top: 1px solid rgba(0,0,0,.08);
  width: 15%;
}
#table-detalhes-produto tr td:first-child {
  padding-left: 8px;
}
#table-detalhes-produto tr td {
  padding-top: 7px;
  padding-bottom: 7px;
}
#table-detalhes-produto tr td p {
  margin: 0;
}
#table-detalhes-produto  tr:nth-child(even) {background: #FFFFFF}
#table-detalhes-produto  tr:nth-child(odd) {background: rgba(0,0,0,.04)}
</style>

<style>
.dialog-compra-responsivo .v-data-table__wrapper {
  height: calc(100vh - 117px) !important;
}

#detalhamentoVendas .v-data-table__wrapper {
  height: calc(100vh - 220px) !important;
}

.dialog-compra-responsivo .v-data-table__wrapper {
  overflow: auto !important;
}

#detalhamentoVendas .v-data-table__wrapper {
  overflow: auto !important;
}

.ptt-10 .v-data-table__wrapper table thead tr th {
  padding-top: 10px;
}

#table-ultimas-compras .v-data-table__wrapper {
  height: calc(100vh - 135px) !important;
}
#select-filial-chart
.v-text-field.v-text-field--enclosed
.v-text-field__details,
#select-filial-chart
.v-text-field.v-text-field--enclosed
> .v-input__control
> .v-input__slot {
  width: 100px;
  margin: 0;
  max-height: 25px !important;
  min-height: 25px !important;
  display: flex !important;
  align-items: center !important;
  font-size: 12px;
}
#select-filial-chart
.v-text-field.v-text-field--enclosed
> .v-input__control
> .v-input__slot
> .v-select__slot
label {
  margin-top: 9px;
}
#select-filial-chart .v-text-field.v-text-field--enclosed {
  font-size: 19px;
}
.font-select-filial-chart {
  font-size: 12px;
}
</style>
